import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BaseService } from './../services/base.service';


@Component({
  selector: 'app-base',
  template: ``,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BaseComponent {
  constructor(protected _baseService: BaseService) {}


  ngOnDestroy(): void {}
}